module.exports = __webpack_public_path__ + "img/header.1bb459b8.png";